import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static values = { returnFocusId: String, fallbackFocusId: String };

  close(event) {
    event?.preventDefault();

    const frame = this.element.closest("turbo-frame");
    this.element.close();
    frame?.remove();

    window.requestAnimationFrame(() => this.restoreFocus());
  }

  restoreFocus() {
    const target = [this.returnFocusIdValue, this.fallbackFocusIdValue]
      .map((id) => document.getElementById(id))
      .find((element) => element && element.getClientRects().length > 0);

    target?.focus({ preventScroll: true });
  }
}
